export interface RuleMatch {
  email_domain?: string
  email?: string
}

export interface RuleGrants {
  role?: string
  sites?: string[]
  apps?: string[]
  apis?: string[]
}

export interface AccessRule {
  match: RuleMatch
  grants: RuleGrants
  // 備考（用途・担当者・期限など）。認可判定には使われない
  note?: string
}

export interface AccessRules {
  rules: AccessRule[]
}

export const VALID_APPS = [
  'portal',
  'monitoring',
  'api-tester',
  'user-management',
  'map-manager',
  'map-editor',
  'map-editor-stg',
  'map-editor-dev',
  'web-simulator',
  'notification-manager',
  'playback-editor',
  'device-manager',
] as const
export const VALID_APIS = [
  'route-search',
  'map-storage',
  'notifications',
  // WCS (Open-RMF 互換タスク API: /tasks, /fleets, /building_map)。WMS 連携先にだけ付与する
  'rmf',
] as const
export const VALID_ROLES = ['admin'] as const
